import { Label, ListBox, Select } from "@heroui/react";
import { formatIdr, skuLabel } from "../lib/format";
import type { ProductSku } from "../lib/types";

export function SkuPicker({
  skus,
  value,
  onChange,
}: {
  skus: ProductSku[];
  value: string;
  onChange: (skuId: string) => void;
}) {
  if (skus.length === 0) return null;

  return (
    <Select
      selectedKey={value}
      onSelectionChange={(key) => {
        if (typeof key === "string" && key) onChange(key);
      }}
      fullWidth
    >
      <Label>Varian</Label>
      <Select.Trigger>
        <Select.Value />
        <Select.Indicator />
      </Select.Trigger>
      <Select.Popover>
        <ListBox>
          {skus.map((sku) => (
            <ListBox.Item
              key={sku.id}
              id={sku.id}
              textValue={`${skuLabel(sku)} ${formatIdr(sku.price)}`}
            >
              {skuLabel(sku)} · {formatIdr(sku.price)}
              {sku.available < 1 ? " · habis" : ""}
            </ListBox.Item>
          ))}
        </ListBox>
      </Select.Popover>
    </Select>
  );
}
